import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { RenderMapIcon } from './RenderChatIcon';
import { useSelector, useDispatch } from 'react-redux';
import { getAssetColor, getFirstAndLastNameFromFullName, GetQueryParam, isLogged, validateStringValue } from '../../utils/common';
import { useNavigate } from 'react-router-dom';
import { trackSupportTicket } from '../../router/roleWisePageRoute';
import { RibbonContainer } from '../../components/TicketExecution/RibbonContainer';
import { Skeleton } from '@mui/material';
import ButtonScogoPrimary from '../../common/Buttons/ButtonScogoPrimary';
import { useForm } from 'react-hook-form';
import { loginWithOTPAction, removeOTPSuccessFromStore, requestOtpSupport } from '../../actions/auth';
import { sendToastMessage } from '../../actions/toast';
import config from '../../config';
import development from '../../config/env/development';
import Form from '../../common/Form';
import Input from '../../common/Form/Input';
import Progress from '../Payments/SideBarComponents/ProgressBar';
import { isMilestoneStatusInRange, MilestoneSubStatus, TicketAgentRole } from '../Ticket/TicketController';
import { generateSignoffReport, generateTicketReport, getSupportTrackTicketDetails } from '../../actions/service_request';
import { copyToClipboard } from '../../actions/utils';
import OverflowTip from '../../common/OverflowTip';
import UserPopup from '../../common/Popups/User';
import IconToolTip from '../../common/IconToolTip';
import ButtonScogoOrange from '../../common/Buttons/ButtonScogoOrange';
import { LineClampComponent } from '../Ticket/TicketTableComponent';
import AssetPopup from '../../common/Popups/AssetPop';
import moment from 'moment';
import { SkeltonCardTwo } from '../../common/SkeltonCardTwo';
import { getAuthRoute } from '../../router/Routes';

export default function RenderTicketDetails({ ticketId, isLiveTrackingEnabled, isMobileView, showActions = false }) {
    const supportTrackServiceRequest = useSelector((state) => state.serviceRequest.supportTrackServiceRequest);
    const supportTrackServiceRequestError = useSelector((state) => state.serviceRequest.supportTrackServiceRequestError);
    const isSupportTrackServiceRequestLoading = useSelector((state) => state.loading.isSupportTrackServiceRequestLoading);
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const shared_by = GetQueryParam('shared_by');

    useEffect(() => {
        if (ticketId && !newLoggedUserData) {
            dispatch(getSupportTrackTicketDetails({ ticketId }))
        }
    }, [ticketId, dispatch, newLoggedUserData]);


    const memoizedTicketDetails = useMemo(() => {
        let details = {};
        if (supportTrackServiceRequest) details = supportTrackServiceRequest;
        return details;
    }, [supportTrackServiceRequest]);


    const memoizedAgents = useMemo(() => {
        let list = [];
        if (memoizedTicketDetails.agents) {
            let filteredAgents = memoizedTicketDetails.agents.filter(({ role }) => [TicketAgentRole.CLUSTER, TicketAgentRole.PSP, TicketAgentRole.SUPERVISOR, TicketAgentRole.PM, TicketAgentRole.SP, TicketAgentRole.FE].includes(role));
            list.push(...Array.from(new Map(filteredAgents.map(item => [`${item.role}_${item.agent.id}`, item])).values()));
        }
        return list;
    }, [memoizedTicketDetails]);

    const onNextClick = useCallback(async () => {
        let path = `${trackSupportTicket.path}?ticketId=${ticketId}&redirectToChat=true`;
        if (shared_by) path = `${path}&shared_by=${shared_by}`;
        if (newLoggedUserData && isLogged()) {
            navigate(path);
        } else {
            const url = await getAuthRoute({ support_view: true, ticket_id: ticketId });
            window.open(url, '_self');
        }
    }, [ticketId, shared_by, newLoggedUserData, navigate]);


    if (isSupportTrackServiceRequestLoading) {
        return <div className='flex justify-center items-center h-full'>
            <SkeltonCardTwo arr={[1, 2, 3, 4, 5, 6, 7, 8]} />
        </div>
    }

    return <div className="w-full flex flex-col items-center bg-scogolightblue  overflow-hidden h-full">
        <div className='w-full overflow-y-auto overflow-x-hidden py-1 px-4 md:px-8' style={{ maxHeight: '90%' }}>
            <div className={`${isMobileView ? ' gap-4 flex flex-col' : ' flex gap-8'} py-4 h-full`} >

                {/* {showProgressAtTop && <RenderProgress memoizedTicketDetails={memoizedTicketDetails} isLoading={isSupportTrackServiceRequestLoading} openCardDefault />} */}

                <RibbonContainer headerLabel={'Contact'}>
                    <div className=' col-span-2 gap-3 grid grid-cols-2 justify-around mt-[0.5rem]  '>
                        {memoizedAgents?.map((user, i) => {
                            let lastIndex = i === memoizedAgents.length - 1 ? i : 1;
                            let isToShowRanderComponent = memoizedAgents.length % 2 === 0
                            let userLength = memoizedAgents.length
                            return <div
                                key={i}
                                className={`bg-scogolightblue  mt-3 border text-center cursor-pointer rounded-md w-full shadow-md  ${lastIndex % 2 === 0 ? 'col-span-2' : ''
                                    }`}
                            >
                                <div className='relative bg-scogoorange '>
                                    <p className='bg-scogoorange text-white text-font10 px-2  shadow-md rounded-3px w-full truncate'>{user.role}</p>

                                    {isToShowRanderComponent && <p className='ml-auto absolute right-2 text-left text-white' style={{ top: '0rem' }}>
                                        {user.renderComponent ? user.renderComponent : <></>}
                                    </p>}
                                </div>
                                <div className='mt-1 px-2 ' >
                                    {(user?.agent?.id && isLogged()) ? <UserPopup
                                        userId={user?.agent?.id}
                                        anchorOrigin={{
                                            vertical: 'center',
                                            horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                    >
                                        <span className='text-font11  text-scogoprimary pt-6 font-semibol max-w-5/7 m-auto'>
                                            <OverflowTip someLongText={user.agent.display_name} />
                                        </span>
                                    </UserPopup> : <p className='text-font11 text-scogoprimary font-semibol max-w-5/7 m-auto'>
                                        <OverflowTip someLongText={user.agent.display_name} />
                                    </p>}
                                    <div className='flex justify-center relative'>
                                        <p className='text-font10 font-normal text-scogogray' onClick={(e) => {
                                            dispatch(copyToClipboard({ data: user.agent.phone_number }));
                                        }}>{user.agent.phone_number}</p>
                                        {userLength % 2 === 1 && <p className='ml-auto absolute right-2 text-left text-font11 hover:text-scogoorange text-scogoprimary'>
                                            {user.renderComponent ? user.renderComponent : <></>}
                                        </p>}
                                    </div>

                                </div>
                            </div>
                        })}
                    </div>
                </RibbonContainer>

                {/* {(!showProgressAtTop && memoizedTicketDetails && memoizedTicketDetails?.accepted_sp_id > 0) && <RenderProgress memoizedTicketDetails={memoizedTicketDetails} isLoading={isSupportTrackServiceRequestLoading} openCardDefault={!isMobileView} />} */}

                {memoizedTicketDetails && <RenderBasicInfo serviceRequest={memoizedTicketDetails} />}
                <RenderMapIcon hide={!isLiveTrackingEnabled} />
            </div>
        </div>
        {showActions && <div style={{ height: '10%' }} className='flex gap-2 justify-end py-4 px-4'>
            <ButtonScogoPrimary buttonPadding='px-10 py-2 text-font15 md:text-font12' textOrComponent={'Next'} onClick={onNextClick} />
        </div>}
    </div>
}


const RenderBasicInfo = ({ serviceRequest }) => {
    const dispatch = useDispatch();
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);
    const disabledClass = 'text-black flex items-center justify-center rounded-6px shadow-primaryBtnShadow px-4 text-xl gap-1 font-medium relative cursor-not-allowed border-scogoddd bg-scogoddd m-auto py-1';


    const sow = serviceRequest.attributes?.find((item) => item.key === 'sow');
    const report = serviceRequest.milestones && isMilestoneStatusInRange(serviceRequest.milestones, MilestoneSubStatus.SIGN_OFF_ACCEPTED);
    const signoff_sample = !report && serviceRequest.attributes?.find((item) => item.key === 'signoff_sample');

    const execution_dates = useMemo(() => {
        let dates = [];
        serviceRequest.milestones?.map(({ execution_dates }) => {
            dates.push(...execution_dates);
        });
        return dates;
    }, [serviceRequest.milestones]);

    const onSignOfflick = () => {
        if (serviceRequest.metadata && serviceRequest.metadata.sign_off_template_id) {
            dispatch(generateSignoffReport({ ticketId: serviceRequest.id, formName: 'generateSignoffReport' }));
        } else {
            window.open(signoff_sample.value.link, '_blank')
        }
    }

    const scogoReport = () => {
        dispatch(generateTicketReport({ ticketId: serviceRequest.id, formName: 'generateTicketReport' }));
    }

    return <div className=' relative '>
        <RibbonContainer headerLabel={'Basic Info'} isCollapsible>

            <div className='absolute right-2 flex gap-x-1 top-4 '>
                {sow && <IconToolTip title='SOW'>
                    <span>
                        <ButtonScogoOrange disabledClass={disabledClass} loading={false} textOrComponent={'SOW'} onClick={() => window.open(sow.value.link, '_blank')} />
                    </span>
                </IconToolTip>
                }
                {signoff_sample && <IconToolTip title='Sign Off Sample'>
                    <span>
                        <ButtonScogoOrange disabledClass={disabledClass} loading={formButtonLoading['generateSignoffReport']} textOrComponent={'Sign Off Sample'} onClick={onSignOfflick} />
                    </span>
                </IconToolTip>}
                {report && <IconToolTip title='Scogo Report'>
                    <span>
                        <ButtonScogoOrange disabledClass={disabledClass} loading={formButtonLoading['generateTicketReport']} textOrComponent={'Scogo Report'} onClick={() => scogoReport(serviceRequest.id)} />
                    </span>
                </IconToolTip>}
            </div>

            <div className='w-full gap-x-2 grid grid-cols-2 gap-y-2 justify-around  col-span-2 mt-14'>
                {serviceRequest?.project?.name && (
                    <OverflowTip someLongText={` ${serviceRequest.project.name}`} textClass="text-font10 font-normal text-scogograytext-scogoprimary" />

                )}
                <div className='text-center '>
                    {(serviceRequest.use_case_name || serviceRequest.service_type) && (
                        <OverflowTip textClass={"text-font11 text-scogoprimary text-center"} someLongText={` ${serviceRequest.use_case_name ? serviceRequest.use_case_name : ""} ${serviceRequest.service_type && serviceRequest.use_case_name ? '/' : ''} ${serviceRequest.service_type && ` ${serviceRequest.service_type} `}`} />

                    )}
                </div>
                <div className=' flex w-full   col-span-2'>
                    <p className='flex w-11/12 '>
                        <p className='w-[17%] text-font11  text-scogogray' >Address : </p>
                        <p className='w-[80%] text-font11 '>
                            <OverflowTip
                                someLongText={`${validateStringValue(serviceRequest?.location?.address)}`}
                            />
                        </p>
                    </p>

                    <p className='ml-auto px-2'>
                        <IconToolTip placement={'bottom'} title={`Copy Site Address`}>
                            <span
                                className='cursor-pointer material-icons text-scogobgsky text-lg '
                                onClick={() =>
                                    dispatch(
                                        copyToClipboard({
                                            data: `${validateStringValue(serviceRequest?.location?.address)}`,
                                        })
                                    )
                                }
                            >
                                content_copy
                            </span>
                        </IconToolTip>
                    </p>
                </div>

                {serviceRequest?.location?.external_id > 0 && (
                    <div className='col-span-2'>
                        <p className='text-font11 mb-1 text-scogogray'>Site id: {serviceRequest?.location?.external_id}</p>
                        <div className='flex gap-x-2'>
                            <div className='max-w-8/8'>
                                <OverflowTip someLongText={serviceRequest?.location?.external_id} />
                            </div>
                            <div>
                                <IconToolTip placement={'bottom'} title={`Copy Site Address`}>
                                    <span
                                        className='cursor-pointer material-icons text-scogobgsky text-lg'
                                        onClick={() =>
                                            dispatch(
                                                copyToClipboard({
                                                    data: `${serviceRequest?.location?.external_id}`,
                                                })
                                            )
                                        }
                                    >
                                        content_copy
                                    </span>
                                </IconToolTip>
                            </div>
                        </div>
                    </div>
                )}
                <div className='col-span-2'>
                    {(serviceRequest?.project?.description || serviceRequest?.description) && (
                        <>
                            <p className='text-font11 mb-1 text-scogogray'>Description</p>
                            <LineClampComponent value={serviceRequest?.description ? serviceRequest?.description : serviceRequest?.project?.description} />
                        </>
                    )}
                </div>

                <div className='col-span-2  flex   gap-x-7'>
                    <div>
                        <p className='text-font11 mb-1 text-scogogray'>Created At</p>
                        <span className='bg-scogoLogoGreen  text-white max-w-max text-font10 px-2 py-1 rounded-3px'>{moment(serviceRequest.created_at).format('DD MMM YY')}</span>
                    </div>

                    {execution_dates && execution_dates.length > 0 ? (
                        execution_dates.map(({ date }) => {
                            return (
                                <div>
                                    <p className='text-font11 mb-1 text-scogogray'>Execution</p>
                                    <div className='bg-scogoLogoGreen text-white min-w-[5rem] text-center max-w-max m-auto text-font10 px-2 py-1 rounded-3px'>
                                        {moment(date).format('DD MMM YY ')}
                                        <br />
                                        <span className="text-font09" >
                                            {moment(date).format('hh:mm A')}
                                        </span>

                                    </div>
                                </div>
                            )
                        })
                    ) : (
                        <></>
                    )}
                </div>

                <div className='col-span-2'>
                    <h3 className={'text-scogo99 text-font11 font-medium truncate'}>Remark </h3>
                    <div className='flex-wrap flex items-center line clamp-2 gap-x-2'>
                        {serviceRequest.remarks?.length > 0 ? (
                            <>
                                <div className='max-w-8/8 truncate'>
                                    {Array.isArray(serviceRequest.remarks) &&
                                        serviceRequest.remarks?.slice(0, 1)?.map((remark) => {
                                            let someLongText = (remark?.remark?.length > 0 ? remark?.remark : '') + (remark?.event?.length > 0 ? remark?.event : '');
                                            return <OverflowTip someLongText={someLongText} />;
                                        })}
                                </div>
                                {serviceRequest.remarks?.length > 1 && (
                                    <IconToolTip title='View all'>
                                        <span
                                            className='text-font12 round font-normal text-scogoorange cursor-pointer hover:text-scogobgsky'
                                        >
                                            +{serviceRequest.remarks?.length - 1}
                                        </span>
                                    </IconToolTip>
                                )}
                            </>
                        ) : (
                            <>No Remark</>
                        )}
                    </div>
                </div>

                <div className='col-span-2'>
                    <h3 className={'text-scogo99 text-font11 font-medium truncate mb-1'}>BOQ </h3>

                    <div className='flex-wrap flex items-center  gap-x-1 '>
                        {serviceRequest.assets?.slice(0, 4)?.map(({ asset }) => {
                            const status = `${asset?.status?.length > 0 ? ` ${asset?.status}` : ''}`;
                            const workingStatus = `${asset?.working_condition?.length > 0 ? `, ${asset?.working_condition}` : ''}`;
                            return (
                                <IconToolTip title={`${status} ${workingStatus}`} >
                                    <span className={`bg-${getAssetColor(asset)} cursor-pointer text-white max-w-12   text-font10 px-2 flex items-center rounded-3px mb-1`}>
                                        <span className='max-w-4/5 truncate'  >
                                            {(asset?.serial_number?.length > 0 ? asset?.serial_number : asset?.title)}
                                        </span>
                                        <span>
                                            {(asset?.count > 1 ? `: ${asset?.count}` : '')}
                                        </span>
                                        <span className="material-icons text-font12 ml-1 hover:text-scogobgsky" onClick={(event) => {
                                            event.stopPropagation();
                                            const text = asset?.serial_number?.length > 0 ? asset?.serial_number : asset?.title

                                            dispatch(copyToClipboard({ data: text }))
                                        }}>
                                            content_copy
                                        </span>
                                    </span>
                                </IconToolTip>
                            );
                        })}

                        {serviceRequest.assets?.length > 4 && (
                            <>

                                <AssetPopup assetList={serviceRequest.assets?.slice(4)} anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }} >
                                    <span className='text-font12 round font-normal text-scogoorange relative cursor-pointer hover:text-scogobgsky countOfBOQ'>
                                        +{serviceRequest.assets?.length - 4}
                                    </span>
                                </AssetPopup>

                            </>
                        )}
                    </div>
                </div>
            </div>
        </RibbonContainer>
    </div>
}

const RenderProgress = ({ isLoading, memoizedTicketDetails, openCardDefault }) => {
    return <RibbonContainer isCollapsible headerLabel={'Progress'} childrenClass='justify-around mt-[2rem] w-full' openCardDefault={openCardDefault} >
        {isLoading ? (
            <div className='flex flex-col h-full items-center justify-center'>
                <Skeleton sx={{ background: 'rgb(221,221,221)' }} variant='rectangular' width={300} height={90} animation='wave' />

            </div>
        ) :
            <div >
                <Progress ticket={memoizedTicketDetails} />
            </div>
        }
    </RibbonContainer>
};





const requestOtp = 'Request OTP';
const submitText = 'Submit';
export const LoginForm = ({ ticketId, redirect_to }) => {
    const defaultValues = {}
    const methods = useForm({ defaultValues, mode: 'all' });
    const submitRef = useRef(null);
    const { requestOTPSuccess } = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const { isRequestOtpButtonLoading, isOtpButtonLoading } = useSelector((state) => state.loading);
    const buttonName = requestOTPSuccess ? submitText : requestOtp;
    const { uiConfig } = useSelector(state => state.user);
    const navigate = useNavigate();

    useEffect(() => {
        return () => dispatch(removeOTPSuccessFromStore());
    }, [dispatch]);

    const onSubmit = (formValues) => {
        if (formValues.name.trim().length === 0) {
            dispatch(sendToastMessage({ status: 'warning', message: 'Please enter valid name.' }));
            return;
        }

        if (buttonName === requestOtp || !requestOTPSuccess) {
            const { first_name, last_name } = getFirstAndLastNameFromFullName(formValues.name)
            const data = { first_name, last_name, skip: true, mobile: formValues.mobile, logged_in_from: 'support_view' };
            if (ticketId) {
                data.ticketId = ticketId;
            } else if (uiConfig?.customer_id) {
                data.customer_id = uiConfig.customer_id;
            } else if (window.location.hostname === 'localhost' || config.name === development.name) {
                data.customer_id = 1;
            }
            dispatch(requestOtpSupport(data));
        } else {
            dispatch(loginWithOTPAction({ mobile: formValues.mobile, otp: formValues.otp, logged_in_from: 'support_view', redirect_to, navigate }))
        }
    };

    return <>
        <div className='overflow-y-auto w-full px-4'>
            <Form
                methods={methods}
                onSubmit={onSubmit}
                submitButtonText={'Update'}
                submitContainerClassName='py-4 px-4'
                showCancelButton={false}
                submitRef={submitRef}
                onEnterPressSubmit
            >
                <div className='grid grid-cols-1 rows-fr grid-flow-row-dense'>
                    <Input label='Name' name='name' type={'text'} required validate={(value) => value.trim().length > 0 || 'Invalid Name'} autofocus />
                    <Input label='Mobile' name='mobile' type={'number'} required validate={(value) => value.length === 10 || 'Invalid Mobile'} />
                    {requestOTPSuccess && <Input label='OTP' name='otp' type={'number'} required validate={(value) => value.length === 4 || 'Invalid OTP'} />
                    }
                </div>
            </Form>
        </div>
        <div className='pt-4 pb-20 w-full  '>
            <div className='flex justify-center w-full'>
                <ButtonScogoPrimary onClick={(e) => {
                    e.preventDefault();
                    submitRef.current.click();
                }}
                    buttonTextClass={'submitButtonSupportText'}
                    loading={isRequestOtpButtonLoading || isOtpButtonLoading}
                    textOrComponent={buttonName}
                />
            </div>
        </div>
    </>
}
